// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--3mBiF";
export var footer__column = "Footer-module--footer__column--1HyP9";
export var footer__slice = "Footer-module--footer__slice--2iTz3";
export var footer__slice_logo = "Footer-module--footer__slice_logo--2ud8A";
export var footer__slice_subscribe = "Footer-module--footer__slice_subscribe--2yutw";
export var footer__logo = "Footer-module--footer__logo--2QfPL";
export var footer__title = "Footer-module--footer__title--34hyB";
export var footer__item = "Footer-module--footer__item--35gAt";
export var footer__social = "Footer-module--footer__social--2IGTP";
export var footer__subscription = "Footer-module--footer__subscription--266g4";
export var footer__form = "Footer-module--footer__form--1DeIu";
export var footer__input = "Footer-module--footer__input--3f0aU";
export var footer__button = "Footer-module--footer__button--2E0Qi";
export var footer__icon = "Footer-module--footer__icon--1Zej_";
export var footer__fixed = "Footer-module--footer__fixed--1x7BS";